import React from "react";

import { doyDisplay, moyDisplay, toMoY, todayDoY } from "js/dateish";
import { LinkDoY, LinkMoY } from "web/ui/date_link";

import classes from './bird_page.module.css';
import { useSelector } from "react-redux";
import type { RootState } from "web/store";

import NeedsList from "web/ui/needs_list";

const HomePage = () => {
  const today = todayDoY();
  const month = toMoY(today);

  const needsRegion = useSelector((state: RootState) => state.app.currentRegion);

  return <div className={ classes.root }>
    <LinkMoY moy={ month }>{ moyDisplay(month) }</LinkMoY>
    <LinkDoY doy={ today } >{ doyDisplay(today) }</LinkDoY>
    { needsRegion && <div>{ `NEEDS: ${needsRegion.name} (${needsRegion.code})` }</div> }
    <NeedsList date={ { kind: 'doy', value: today } } />
  </div>;
}

export default HomePage;
